module.exports = __webpack_public_path__ + "img/ic_foot_hight_0.85141443.png";